<template>
  <div
    class="d-flex justify-center reactions"
    :class="{
      'white': slide.textColour === '#ffffff',
      'pb-120': (slide.type === 'pickAnswer' && slide.slideType !== 'typeAnswer') ||
        slide.type === 'multipleChoice' || slide.type === 'imageChoice',
      'pb-190': slide.type === 'multipleChoice' || slide.type === 'imageChoice',
      'show': isShowReaction,
    }"
  >
    <span class="mr-2 ml-2">
      <div
        class="icon-reaction horizontal layout center center-justified"
        @click="reactClick(like)"
        ref="elLike"
        :class="{'active': activeLike}"
      >
        <span ref="iconLike" class="horizontal layout center center-justified">
          <img
            :src="like.icon"
            class="normal"
            v-if="!like.active"
          >
          <img :src="like.iconActive" alt="" v-else>
        </span>
      </div>
      <div
        class="text-center react-count"
        :class="{ 'animate__bounceIn animate__animated': animationCountLike}"
      >
        <AhaFormatter :value="presentation.numberOfLikes" type="KMB" />
      </div>
    </span>
    <span class="mr-2 ml-2">
      <div
        class="icon-reaction horizontal layout center center-justified"
        @click="reactClick(heart)"
        ref="elHeart"
        :class="{'active': activeHeart}"
      >
        <span ref="iconHeart" class="horizontal layout center center-justified">
          <img :src="heart.icon" class="normal" v-if="!heart.active">
          <img :src="heart.iconActive" alt="" v-else>
        </span>
      </div>
      <div
        class="text-center react-count"
        :class="{ 'animate__bounceIn animate__animated': animationCountHeart }"
      >
        <AhaFormatter :value="presentation.numberOfHearts" type="KMB" />
      </div>
    </span>
    <span class="mr-2 ml-2">
      <div
        class="icon-reaction horizontal layout center center-justified"
        @click="reactClick(laugh)"
        ref="elHaha"
        :class="{'active': activeLaugh}"
      >
        <span ref="iconHaha" class="horizontal layout center center-justified">
          <img :src="laugh.icon" class="normal" v-if="!laugh.active">
          <img :src="laugh.iconActive" alt="" v-else>
        </span>
      </div>
      <div
        class="text-center react-count"
        :class="{ 'animate__bounceIn animate__animated': animationCountLaugh}"
      >
        <AhaFormatter :value="presentation.numberOfLaughs" type="KMB" />
      </div>
    </span>
    <span class="mr-2 ml-2">
      <div
        class="icon-reaction horizontal layout center center-justified"
        @click="reactClick(wow)"
        ref="elWow"
        :class="{'active': activeWow}"
      >
        <span ref="iconWow" class="horizontal layout center center-justified">
          <img :src="wow.icon" class="normal" v-if="!wow.active">
          <img :src="wow.iconActive" alt="" v-else>
        </span>
      </div>
      <div
        class="text-center react-count"
        :class="{ 'animate__bounceIn animate__animated': animationCountWow}"
      >
        <AhaFormatter :value="presentation.numberOfWows" type="KMB" />
      </div>
    </span>
    <span class="mr-2 ml-2">
      <div
        class="icon-reaction horizontal layout center center-justified"
        @click="reactClick(sad)"
        ref="elSad"
        :class="{'active': activeSad}"
      >
        <span ref="iconSad" class="horizontal layout center center-justified">
          <img :src="sad.icon" class="normal" v-if="!sad.active">
          <img :src="sad.iconActive" alt="" v-else>
        </span>
      </div>
      <div
        class="text-center react-count"
        :class="{ 'animate__bounceIn animate__animated': animationCountSad}"
      >
        <AhaFormatter :value="presentation.numberOfSads" type="KMB" />
      </div>
    </span>
  </div>
</template>
<script>
/* eslint-disable no-new */
import mojs from '@mojs/core'
import { mapState } from 'vuex'
import _ from 'lodash'
import EventBus from '@/eventBus'
import storage from '@/services/storage'
import util from '@/util'

export default {
  props: {
    react: {
      type: Function,
      required: true,
    },
    presentation: {
      type: Object,
      required: true,
    },
    heart: {
      type: Object,
      required: true,
    },
    laugh: {
      type: Object,
      required: true,
    },
    like: {
      type: Object,
      required: true,
    },
    sad: {
      type: Object,
      required: true,
    },
    wow: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeHeart: false,
      activeLaugh: false,
      activeLike: false,
      activeSad: false,
      activeWow: false,
      animationCountHeart: false,
      animationCountLaugh: false,
      animationCountLike: false,
      animationCountSad: false,
      animationCountWow: false,
      isShowReaction: false,
      disableClickReaction: false,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      slide: (state) => state.slide,
    }),
  },
  mounted() {
    this.initAnimocon()
    setTimeout(() => {
      this.isShowReaction = true
    }, 250)
    EventBus.$on('reaction-animation', (data) => {
      const {
        numberOfLikes,
        numberOfHearts,
        numberOfLaughs,
        numberOfSads,
        numberOfWows,
      } = this.presentation
      if (data.numberOfHearts !== numberOfHearts && !this.animationCountHeart) {
        this.animationCountHeart = true
        setTimeout(() => {
          this.animationCountHeart = false
        }, 2000)
      }

      if (data.numberOfLikes !== numberOfLikes && !this.animationCountLike) {
        this.animationCountLike = true
        setTimeout(() => {
          this.animationCountLike = false
        }, 2000)
      }
      if (data.numberOfLaughs !== numberOfLaughs && !this.animationCountLaugh) {
        this.animationCountLaugh = true
        setTimeout(() => {
          this.animationCountLaugh = false
        }, 2000)
      }
      if (data.numberOfSads !== numberOfSads && !this.animationCountSad) {
        this.animationCountSad = true
        setTimeout(() => {
          this.animationCountSad = false
        }, 2000)
      }
      if (data.numberOfWows !== numberOfWows && !this.animationCountWow) {
        this.animationCountWow = true
        setTimeout(() => {
          this.animationCountWow = false
        }, 2000)
      }
    })
  },
  destroyed() {
    EventBus.$off('reaction-animation')
  },
  methods: {
    resetAnimation(el) {
      const arr = el.querySelectorAll('[data-name="mojs-shape"]')
      el.isLoading = true
      setTimeout(() => {
        arr.forEach((item) => {
          item.style.transform = 'scale(0)'
        })
      }, 500)
    },
    reaction() {
      // do not thing
    },
    reactClick(reaction) {
      if (this.disableClickReaction || !this.slide.id) return
      this.disableClickReaction = true
      this._throttleReaction(reaction)
      if (reaction.name === 'heart') {
        this.$store.state.presentation.numberOfHearts++
      }
      if (reaction.name === 'like') {
        this.$store.state.presentation.numberOfLikes++
      }
      if (reaction.name === 'laugh') {
        this.$store.state.presentation.numberOfLaughs++
      }
      if (reaction.name === 'sad') {
        this.$store.state.presentation.numberOfSadss++
      }
      if (reaction.name === 'wow') {
        this.$store.state.presentation.numberOfWows++
      }
      const reactions = storage.getValueByPresentation(this.presentation.id, 'reactionsByPesentation', [])
      if (!reactions.includes(reaction.name)) {
        reactions.push(reaction.name)
        storage.setValueByPresentation(
          this.presentation.id,
          'reactionsByPesentation',
          reactions,
        )
      }
    },

    _throttleReaction: _.throttle(function reactClick(reaction) {
      this.react(reaction.name)
      if (reaction.name === 'heart') {
        this.activeHeart = true
      }
      if (reaction.name === 'like') {
        this.activeLike = true
      }
      if (reaction.name === 'laugh') {
        this.activeLaugh = true
      }
      if (reaction.name === 'sad') {
        this.activeSad = true
      }
      if (reaction.name === 'wow') {
        this.activeWow = true
      }
      this.animationReaction()
      this.disableClickReaction = false
      util.gaTrackEvent(
        'Audience > Reactions',
        `Audience > Click reaction ${reaction.name}`,
        '',
      )
    }, 1000),
    animationReaction: _.debounce(function animationReaction() {
      this.activeHeart = false
      this.activeLaugh = false
      this.activeLike = false
      this.activeSad = false
      this.activeWow = false
    }, 1000),
    initAnimocon() {
      const selfComponent = this
      // taken from mo.js demos
      function isIOSSafari() {
        const { userAgent } = window.navigator
        return userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)
      }

      // taken from mo.js demos
      function isTouch() {
        const isIETouch = navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
        return [].indexOf.call(window, 'ontouchstart') >= 0 || isIETouch
      }

      // taken from mo.js demos
      const isIOS = isIOSSafari()
      const clickHandler = isIOS || isTouch() ? 'touchstart' : 'click'

      function extend(a, b) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in b) {
          // eslint-disable-next-line no-prototype-builtins
          if (b.hasOwnProperty(key)) {
            a[key] = b[key]
          }
        }
        return a
      }

      function Animocon(el, options) {
        this.el = el
        this.options = extend({}, this.options)
        extend(this.options, options)

        this.checked = false

        this.timeline = new mojs.Timeline()

        for (let i = 0, len = this.options.tweens.length; i < len; ++i) {
          this.timeline.add(this.options.tweens[i])
        }

        this.el.addEventListener(clickHandler, () => {
          this.options.onCheck()
          this.timeline.replay()
          this.checked = !this.checked
        })
      }

      Animocon.prototype.options = {
        tweens: [new mojs.Burst({})],
        onCheck() {
          return false
        },
        onUnCheck() {
          return false
        },
      }

      // Icon Heart
      const el14 = this.$refs.elHeart
      const el14span = this.$refs.iconHeart

      new Animocon(el14, {
        tweens: [
          // ring animation
          new mojs.Shape({
            parent: el14,
            duration: 750,
            type: 'circle',
            radius: { 0: 40 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 35: 0 },
            opacity: 0.2,
            top: '45%',
            easing: mojs.easing.bezier(0, 1, 0.5, 1),
          }),
          new mojs.Shape({
            parent: el14,
            duration: 500,
            delay: 100,
            type: 'circle',
            radius: { 0: 20 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 5: 0 },
            opacity: 0.2,
            x: 40,
            y: -60,
            easing: mojs.easing.sin.out,
          }),
          new mojs.Shape({
            parent: el14,
            duration: 500,
            delay: 180,
            type: 'circle',
            radius: { 0: 10 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 5: 0 },
            opacity: 0.5,
            x: -10,
            y: -80,
            isRunLess: true,
            easing: mojs.easing.sin.out,
          }),
          new mojs.Shape({
            parent: el14,
            duration: 800,
            delay: 240,
            type: 'circle',
            radius: { 0: 20 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 5: 0 },
            opacity: 0.3,
            x: -70,
            y: -10,
            easing: mojs.easing.sin.out,
          }),
          new mojs.Shape({
            parent: el14,
            duration: 800,
            delay: 240,
            type: 'circle',
            radius: { 0: 20 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 5: 0 },
            opacity: 0.4,
            x: 80,
            y: -50,
            easing: mojs.easing.sin.out,
          }),
          new mojs.Shape({
            parent: el14,
            duration: 1000,
            delay: 300,
            type: 'circle',
            radius: { 0: 15 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 5: 0 },
            opacity: 0.2,
            x: 20,
            y: -100,
            easing: mojs.easing.sin.out,
          }),
          new mojs.Shape({
            parent: el14,
            duration: 600,
            delay: 330,
            type: 'circle',
            radius: { 0: 25 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 5: 0 },
            opacity: 0.4,
            x: -40,
            y: -90,
            easing: mojs.easing.sin.out,
          }),
          // icon scale animation
          new mojs.Tween({
            duration: 1200,
            easing: mojs.easing.ease.out,
            onUpdate(progress) {
              if (progress > 0.3) {
                const elasticOutProgress = mojs.easing.elastic.out(
                  1.43 * progress - 0.43,
                )
                el14span.style.transform = `scale3d(${elasticOutProgress}, ${elasticOutProgress}, 1)`
                el14span.style.WebkitTransform = el14span.style.transform
              } else {
                el14span.style.transform = 'scale3d(0, 0, 1)'
                el14span.style.WebkitTransform = el14span.style.transform
              }
            },
          }),
        ],
        onCheck() {
          selfComponent.reaction('heart', el14)
          selfComponent.resetAnimation(el14)
        },
      })

      // Icon like

      const el9 = this.$refs.elLike
      const el9span = this.$refs.iconLike
      el9span.style.transformOrigin = '-10% 50%'
      el9span.style.WebkitTransformOrigin = el9span.style.transformOrigin
      new Animocon(el9, {
        tweens: [
          // burst animation
          new mojs.Burst({
            parent: el9,
            count: 6,
            radius: { 40: 90 },
            angle: 135,
            degree: 90,
            children: {
              fill: [
                '#FFC700',
                '#DE8AA0',
                '#8AAEDE',
                '#8ADEAD',
                '#DEC58A',
                '#8AD1DE',
              ],
              scale: 1,
              radius: { 7: 0 },
              opacity: 0.6,
              duration: 1500,
              delay: 350,
              easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
            },
          }),
          // burst animation
          new mojs.Burst({
            parent: el9,
            count: 6,
            angle: 45,
            degree: -90,
            radius: { 40: 100 },
            children: {
              fill: [
                '#FFC700',
                '#DE8AA0',
                '#8AAEDE',
                '#8ADEAD',
                '#DEC58A',
                '#8AD1DE',
              ],
              scale: 1,
              radius: { 7: 0 },
              opacity: 0.6,
              duration: 1500,
              delay: 550,
              easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
            },
          }),
          // ring animation
          new mojs.Shape({
            parent: el9,
            radius: { 0: 50 },
            fill: 'transparent',
            stroke: '#3393F6',
            strokeWidth: { 35: 0 },
            opacity: 0.6,
            duration: 750,
            easing: mojs.easing.bezier(0, 1, 0.5, 1),
          }),
          // ring animation
          new mojs.Shape({
            parent: el9,
            radius: { 0: 50 },
            fill: 'transparent',
            stroke: '#3393F6',
            strokeWidth: { 35: 0 },
            opacity: 0.6,
            duration: 750,
            delay: 200,
            easing: mojs.easing.bezier(0, 1, 0.5, 1),
          }),
          // icon scale animation
          new mojs.Tween({
            duration: 1500,
            onUpdate(progress) {
              if (progress > 0.3) {
                const elasticOutProgress = mojs.easing.elastic.out(
                  1.43 * progress - 0.43,
                )
                el9span.style.transform = `scale3d(${elasticOutProgress}, ${elasticOutProgress},1) rotate3d(0,0,1,${90 * (1 - elasticOutProgress)}deg)`
                el9span.style.WebkitTransform = el9span.style.transform
              } else {
                el9span.style.transform = 'scale3d(0,0,1)'
                el9span.style.WebkitTransform = el9span.style.transform
              }
            },
          }),
        ],
        onCheck() {
          el9.style.color = '#FFC700'
          selfComponent.reaction('haha', el9)
          selfComponent.resetAnimation(el9)
        },
      })

      // Icon laugh
      const el5 = this.$refs.elHaha
      const el5span = this.$refs.iconHaha
      new Animocon(el5, {
        tweens: [
          // burst animation
          new mojs.Burst({
            parent: el5,
            count: 15,
            radius: { 20: 80 },
            angle: { 0: 140, easing: mojs.easing.bezier(0.1, 1, 0.3, 1) },
            children: {
              fill: '#FFD687',
              radius: 20,
              opacity: 0.6,
              duration: 1500,
              easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
            },
          }),
          // icon scale animation
          new mojs.Tween({
            duration: 800,
            easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
            onUpdate(progress) {
              el5span.style.transform = `scale3d(${progress},${progress},1)`
              el5span.style.WebkitTransform = el5span.style.transform
            },
          }),
        ],
        onCheck() {
          selfComponent.reaction('like', el5)
          selfComponent.resetAnimation(el5)
        },
      })

      // Icon wow
      const el6 = this.$refs.elWow
      const el6span = this.$refs.iconWow
      new Animocon(el6, {
        tweens: [
          // burst animation
          new mojs.Burst({
            parent: el6,
            radius: { 40: 110 },
            count: 20,
            children: {
              shape: 'line',
              fill: 'white',
              radius: { 12: 0 },
              scale: 1,
              stroke: '#FFD687',
              strokeWidth: 2,
              duration: 1500,
              easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
            },
          }),
          // ring animation
          new mojs.Shape({
            parent: el6,
            radius: { 10: 60 },
            fill: 'transparent',
            stroke: '#FFD687',
            strokeWidth: { 30: 0 },
            duration: 800,
            easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
          }),
          // icon scale animation
          new mojs.Tween({
            duration: 800,
            easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
            onUpdate(progress) {
              el6span.style.transform = `scale3d(${progress}, ${progress}, 1)`
              el6span.style.WebkitTransform = el6span.style.transform
            },
          }),
        ],
        onCheck() {
          selfComponent.reaction('wow', el6)
          selfComponent.resetAnimation(el6)
        },
      })

      /* IconSad */
      const el11 = this.$refs.elSad
      const el11span = this.$refs.iconSad
      const opacityCurve11 = mojs.easing.path('M0,0 C0,87 27,100 40,100 L40,0 L100,0')
      const scaleCurve11 = mojs.easing.path('M0,0c0,80,39.2,100,39.2,100L40-100c0,0-0.7,106,60,106')
      new Animocon(el11, {
        tweens: [
          // ring animation
          new mojs.Shape({
            parent: el11,
            radius: { 0: 95 },
            fill: 'transparent',
            stroke: '#FFD687',
            strokeWidth: { 50: 0 },
            opacity: 0.4,
            duration: 1000,
            delay: 100,
            easing: mojs.easing.bezier(0, 1, 0.5, 1),
          }),
          // ring animation
          new mojs.Shape({
            parent: el11,
            radius: { 0: 80 },
            fill: 'transparent',
            stroke: '#FFD687',
            strokeWidth: { 40: 0 },
            opacity: 0.2,
            duration: 1800,
            delay: 300,
            easing: mojs.easing.bezier(0, 1, 0.5, 1),
          }),
          // icon scale animation
          new mojs.Tween({
            duration: 1300,
            easing: mojs.easing.ease.out,
            onUpdate: (progress) => {
              const opacityProgress = opacityCurve11(progress)
              el11span.style.opacity = opacityProgress

              const scaleProgress = scaleCurve11(progress)
              el11span.style.transform = `scale3d(${scaleProgress}, ${scaleProgress}, 1)`
              el11span.style.WebkitTransform = el11span.style.transform

              const colorProgress = opacityCurve11(progress)
              el11.style.color = colorProgress >= 1 ? '#E87171' : '#FFD687'
            },
          }),
        ],
        onCheck() {
          selfComponent.reaction('wow', el11)
          selfComponent.resetAnimation(el11)
        },
      })
      /* Icon 11 */
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.reactions {
  margin-bottom: 24px;
  opacity: 0;
  z-index: 1;

  &.show {
    transition: 0.15s ease-in;
    opacity: 1;
  }

  &.pb-120 {
    margin-bottom: 164px;
  }

  @media (max-width: 768px) {
    &.pb-190 {
      margin-bottom: 210px;
    }
  }

  .img-light {
    display: none;
  }

  .icon-reaction {
    border-radius: 40px;
    cursor: pointer;
    position: relative;

    img {
      width: 48px;
      height: 48px;
    }

    span {
      width: 48px;
      height: 48px;
    }

    @media (max-width: 360px) {
      img {
        width: 40px;
        height: 40px;
      }
      span {
        width: 40px;
        height: 40px;
      }
    }
  }
  .react-count {
    font-size: 14px;
  }
}
</style>
